(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/game-receipt/assets/javascripts/game-receipt.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/game-receipt/assets/javascripts/game-receipt.js');

'use strict';

const format = svs.utils.format;
const lbUtilsHelpers = svs.components.lbUtils.helpers.formatDate;
const gamesHelpers = svs.components.marketplace.helpers.games;
const getStatusDesc = svs.components.marketplace.helpers.games.getStatusDesc;
const _svs$components$marke = svs.components.marketplaceData.gamesConstants,
  GAME_STATUS_FINISHED = _svs$components$marke.GAME_STATUS_FINISHED,
  GAME_STATUS_SUBMITTED = _svs$components$marke.GAME_STATUS_SUBMITTED;
const getGameReceipt = (game, team) => {
  const buyStop = game.buyStop,
    commissionPercent = game.commissionPercent,
    fractionsCount = game.fractionsCount,
    fractionPrice = game.fractionPrice,
    isSoldOut = game.isSoldOut,
    isAllowedToSubmit = game.isAllowedToSubmit,
    isSubmitted = game.isSubmitted,
    maxFractions = game.maxFractions,
    ownerName = game.ownerName,
    playableAmount = game.playableAmount,
    status = game.status;
  const isRetailer = (team === null || team === void 0 ? void 0 : team.type) === 'RETAILER';
  const isLocked = [GAME_STATUS_SUBMITTED, GAME_STATUS_FINISHED].indexOf(status) > -1;
  const shouldShowStatus = new Date(buyStop).getTime() < Date.now() || isSoldOut || isSubmitted;
  const rows = [];

  const renderAmount = function (value) {
    let empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return value ? "".concat(format.Currency(value), " kr") : empty;
  };
  if (isRetailer) {
    if (isLocked) {
      const wagerAmount = game.wagerAmount,
        wagerSharePrice = game.wagerSharePrice,
        soldShares = game.soldShares,
        shareCommission = game.shareCommission;
      rows.push([{
        title: 'Insats per andel',
        text: renderAmount(wagerSharePrice)
      }, {
        title: 'Status',
        text: getStatusDesc(status)
      }]);
      rows.push([{
        title: 'Spelläggare',
        text: ownerName
      }, {
        title: 'Butiksavgift',
        text: renderAmount(shareCommission)
      }]);
      rows.push([{
        title: 'Andelar',
        text: soldShares
      }, {
        title: 'Lagt spel',
        text: renderAmount(wagerAmount)
      }]);
      return rows;
    }
    rows.push([{
      title: 'Andelspris',
      text: renderAmount(fractionPrice)
    }, {
      title: shouldShowStatus ? 'Spelstatus' : 'Sista andelsköp',
      text: shouldShowStatus ? "".concat(gamesHelpers.getStatusDesc(status, isAllowedToSubmit)).concat(isSoldOut ? '*' : '') : lbUtilsHelpers.formatDate(buyStop, true, true, true)
    }]);
    rows.push([{
      title: 'Spelläggare',
      text: ownerName
    }, {
      title: 'Butiksavgift',
      text: commissionPercent ? "".concat(commissionPercent, " % p\xE5 lagt spel") : null
    }]);
    rows.push([{
      title: 'Andelar',
      text: maxFractions
    }, {
      text: 'Om färre andelar säljs kan spelet minskas eller återbetalas.',
      options: {
        className: 'view-header-receipt-column-3',
        textClassName: 'f-200'
      }
    }]);
    return rows;
  }
  const fractionCommittedPrice = game.fractionCommittedPrice,
    wagerAmount = game.wagerAmount;
  rows.push([{
    title: isSubmitted ? 'Insats per andel' : 'Andelspris',
    text: renderAmount(isSubmitted ? fractionCommittedPrice : game.fractionPrice, '-')
  }, {
    title: shouldShowStatus ? 'Spelstatus' : 'Sista andelsköp',
    text: shouldShowStatus ? "".concat(gamesHelpers.getStatusDesc(status, isAllowedToSubmit)).concat(isSoldOut ? '*' : '') : lbUtilsHelpers.formatDate(buyStop, true, true, true)
  }]);
  rows.push([{
    title: 'Sålda andelar',
    text: "".concat(fractionsCount).concat(isSoldOut ? '*' : '')
  }, {
    title: isSubmitted ? 'Lagt spel' : 'Att spela för',
    text: renderAmount(isSubmitted ? wagerAmount : playableAmount, '-')
  }]);
  if (!isRetailer) {
    rows.push([{
      title: 'Andelar',
      text: maxFractions
    }, {
      text: 'Om färre andelar säljs kan spelet minskas eller återbetalas.',
      options: {
        className: 'view-header-receipt-column-3',
        textClassName: 'f-200'
      }
    }]);
  }
  return rows;
};
setGlobal('svs.components.marketplaceShared.gameReceipt.getGameReceipt', getGameReceipt);

 })(window);